import {AfterViewInit, Directive, ElementRef, Renderer2} from '@angular/core';

@Directive({
  selector: 'ul.list-group, ul.list-unstyled',
})
export class AtlasDetailListDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef<HTMLElement>, private renderer: Renderer2) {
    Promise.resolve().then(() => this.enhanceList());
  }

  ngAfterViewInit(): void {
    Promise.resolve().then(() => this.enhanceList());
  }

  private enhanceList(): void {
    const list: HTMLElement = this.elementRef.nativeElement;
    if (list.hasAttribute('data-atlas-detail-off')) {
      return;
    }
    const items: HTMLElement[] = Array.prototype.slice.call(list.children).filter((child: HTMLElement) => child.tagName === 'LI');
    const detailItems: Array<{item: HTMLElement; row: HTMLElement; label: HTMLElement}> = [];

    items.forEach((item: HTMLElement) => {
      const label: HTMLElement = item.querySelector('strong') as HTMLElement;
      if (!label) {
        return;
      }

      const row: HTMLElement = this.findRowContainer(label, item);
      if (row) {
        detailItems.push({item: item, row: row, label: label});
      }
    });

    if (detailItems.length < 3 || detailItems.length / Math.max(items.length, 1) < 0.5) {
      return;
    }

    this.renderer.addClass(list, 'atlas-detail-list');
    detailItems.forEach((detailItem) => {
      this.renderer.addClass(detailItem.item, 'atlas-detail-item');
      this.renderer.addClass(detailItem.row, 'atlas-detail-row');
      this.renderer.addClass(detailItem.label, 'atlas-detail-label');

      const valueElement: HTMLElement = this.findValueElement(detailItem.label);
      if (valueElement) {
        this.renderer.addClass(valueElement, 'atlas-detail-value');
      }
    });
  }

  private findRowContainer(label: HTMLElement, item: HTMLElement): HTMLElement {
    if (label.parentElement === item) {
      return item;
    }

    let current: HTMLElement = label;
    while (current.parentElement && current.parentElement !== item) {
      current = current.parentElement;
    }

    return current.parentElement === item ? current : item;
  }

  private findValueElement(label: HTMLElement): HTMLElement {
    let sibling: ChildNode = label.nextSibling;
    while (sibling) {
      if (sibling.nodeType === Node.ELEMENT_NODE) {
        return sibling as HTMLElement;
      }
      if (sibling.nodeType === Node.TEXT_NODE && (sibling.textContent || '').replace(/[\s:]/g, '')) {
        return null;
      }
      sibling = sibling.nextSibling;
    }
    return null;
  }
}
